// Import dependencies
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import GLightbox from 'glightbox';
import { initialiser } from '../../ramen-imports/utilitybelt';

class CardSlider {
  constructor(config) {
    const { el, settings } = config;

    this.container = el;
    this.swiperInstance = null;
    this.revalidateLazyImages = settings.revalidateLazyImages;
    this.settings = settings;
  }

  init = () => {
    this.initSwiper();

    if (!this.settings.noLightbox) this.initGLightbox();
  };

  initSwiper = () => {
    // Setup Swiper with modules
    this.settings.modules = [Navigation, Pagination];

    this.swiperInstance = new Swiper(this.container, this.settings);

    this.swiperInstance.on('slideChange', () => {
      if (this.revalidateLazyImages) this.revalidateLazyImages();
    });
  };

  initGLightbox = () => {
    // select slides inside current container
    const slides = this.container.querySelector('.swiper-wrapper').querySelectorAll('.swiper-slide:not(.js-no-lightbox)');

    // prepare elements array for gallery instantiation
    const elements = slides.length > 0 && Array.from(slides).map((slide) => {
      const img = slide.querySelector('img');
      const cardLink = slide.querySelector('.js-card-link');
      const { src } = img ? img.dataset : cardLink.dataset;

      return {
        href: src,
        type: 'image',
        title: img ? img.alt : null,
      };
    });

    if (elements.length > 0) {
      // instantiate gallery
      const gallery = elements && GLightbox({
        elements,
        loop: true,
      });

      // open gallery on slide click
      slides.forEach((slide, i) => {
        const eventListenerTarget = slide.querySelector('.c-image__background') || slide.querySelector('.js-card-link');

        eventListenerTarget.addEventListener('click', () => {
          gallery.openAt(i);
        });
      });
    }
  };
}

export default (settings) => initialiser(settings, CardSlider);
